<ejs-dialog #productBrandModal
			cssClass="modal-sm"
			(close)="closeModal(false)">
	<ng-template #header>
		<div class="dlg-template">Add Brand</div>
	</ng-template>
	<ng-template #content>
		<form [formGroup]="formGroup"
			  (ngSubmit)="addProductBrand()"
			  #componentForm="ngForm">
			<div class="row">
				<div class="col-md-12">
					@if (formGroup.invalid && componentForm.submitted) {
						<gandalf-lib-validation-messages
							[form]="formGroup"
							[requestObj]="request">
						</gandalf-lib-validation-messages>
					}
				</div>
			</div>
			<div class="row mb-3">
				<label class="col-md-3 col-form-label">Name</label>
				<div class="col-md-9">
					<input type="text" class="e-input" formControlName="name"/>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #footerTemplate>
		<button ejs-button iconCss="fa fa-times" (click)="closeModal(false)">Cancel</button>
		<button ejs-button isPrimary="true" type="submit" (click)="submitForm($event)">Save</button>
	</ng-template>
</ejs-dialog>
